import React from "react";

const CinemtographyMain = () => {
  return (
    <section className="min-h-screen pb-10 bg-white">

      {/* Main Content */}
      <div className="container max-w-6xl px-4 mx-auto mt-8">
        <div className="flex flex-col items-center gap-8 md:flex-row md:items-start">
          {/* Left: Course Image */}
          <div className="w-full md:w-1/2" data-aos="fade-right">
            <img src="https://sunrisingcinevisionacademy.com/public/assets/images/Cinematography.jpg" alt="Cinematography" className="w-full h-auto rounded-lg shadow-lg" />
          </div>
          {/* Right: Course Intro */}
          <div className="w-full p-2 md:w-1/2" data-aos="fade-left">
            <h2 className="text-2xl font-bold mb-2 text-[#A14D1F]">Master the Art of Cinematography with Sunrising Cinevision Academy</h2>
            <p className="mb-4 text-gray-700">
              Sunrising Cinevision Academy, one of the best film schools, offers a structured cinematography course designed for aspiring filmmakers. Whether you're looking for a diploma in cinematography, a bachelor in cinematography, or even a masters cinematography program, this course covers everything from fundamental techniques to advanced industry practices. Gain hands-on experience with professional equipment and industry mentorship to build a successful career in film and media.
            </p>
            <h2 className="text-xl font-bold mb-2 text-[#A14D1F]">Course Overview</h2>
            <ul className="pl-5 mb-2 space-y-1 text-gray-700 list-disc">
              <li><strong>Level:</strong> Beginner to Advanced</li>
              <li><strong>Duration:</strong> 12-24 weeks</li>
              <li><strong>Certification:</strong> Certificate in Cinematography</li>
              <li><strong>Career Paths:</strong> Cinematographer, Camera Operator, Lighting Technician, Director of Photography</li>
            </ul>
            <h2 className="text-xl font-bold mb-2 mt-5 text-[#A14D1F]">What You Will Learn</h2>
            <ul className="pl-5 mb-2 space-y-1 text-gray-700 list-disc">
              <li>Core concepts of cinematography and visual storytelling</li>
              <li>Mastering camera fundamentals, movement, and stabilization</li>
              <li>Understanding lighting principles, composition, and framing</li>
              <li>Advanced techniques in exposure, metering, and colour grading</li>
              <li>Digital cinematography workflows and post-production techniques</li>
            </ul>
          </div>
        </div>

        {/* Course Modules */}
        <div className="grid grid-cols-1 gap-6 mt-10 md:grid-cols-2">
          <div className="p-8 bg-white shadow-md rounded-xl" data-aos="fade-up">
            <h3 className="uppercase tracking-wide text-xl font-bold text-[#A14D1F]">Module 1: Introduction to Cinematography</h3>
            <ul className="pl-5 space-y-1 text-gray-700 list-disc">
              <li>Definition and history of cinematography</li>
              <li>Role of a cinematographer</li>
              <li>Collaborating with directors and crew</li>
            </ul>
          </div>
          <div className="p-8 bg-white shadow-md rounded-xl" data-aos="fade-up">
            <h3 className="uppercase tracking-wide text-xl font-bold text-[#A14D1F]">Module 2: Camera Fundamentals</h3>
            <ul className="pl-5 space-y-1 text-gray-700 list-disc">
              <li>Types of cameras (film, digital, DSLR)</li>
              <li>Camera components (lens, sensor, shutter)</li>
              <li>Camera settings (ISO, aperture, shutter speed)</li>
            </ul>
          </div>
          <div className="p-8 bg-white shadow-md rounded-xl" data-aos="fade-up">
            <h3 className="uppercase tracking-wide text-xl font-bold text-[#A14D1F]">Module 3: Lighting Principles</h3>
            <ul className="pl-5 space-y-1 text-gray-700 list-disc">
              <li>Light sources (natural, artificial)</li>
              <li>Lighting styles (high-key, low-key)</li>
              <li>Lighting techniques (three-point lighting)</li>
            </ul>
          </div>
          <div className="p-8 bg-white shadow-md rounded-xl" data-aos="fade-up">
            <h3 className="uppercase tracking-wide text-xl font-bold text-[#A14D1F]">Module 4: Composition and Visual Storytelling</h3>
            <ul className="pl-5 space-y-1 text-gray-700 list-disc">
              <li>Framing and composition</li>
              <li>Visual storytelling techniques</li>
              <li>Camera placement and movement</li>
            </ul>
          </div>
          <div className="p-8 bg-white shadow-md rounded-xl" data-aos="fade-up">
            <h3 className="uppercase tracking-wide text-xl font-bold text-[#A14D1F]">Module 5: Camera Movement and Stabilization</h3>
            <ul className="pl-5 space-y-1 text-gray-700 list-disc">
              <li>Camera movement types (pan, tilt, dolly)</li>
              <li>Stabilization techniques (tripod, Steadicam)</li>
              <li>Handheld and shoulder-mounted cameras</li>
            </ul>
          </div>
          <div className="p-8 bg-white shadow-md rounded-xl" data-aos="fade-up">
            <h3 className="uppercase tracking-wide text-xl font-bold text-[#A14D1F]">Module 6: Lens Selection and Optics</h3>
            <ul className="pl-5 space-y-1 text-gray-700 list-disc">
              <li>Lens types (prime, zoom, wide-angle)</li>
              <li>Lens characteristics (focal length, aperture)</li>
              <li>Optical filters and effects</li>
            </ul>
          </div>
          <div className="p-8 bg-white shadow-md rounded-xl" data-aos="fade-up">
            <h3 className="uppercase tracking-wide text-xl font-bold text-[#A14D1F]">Module 7: Exposure and Metering</h3>
            <ul className="pl-5 space-y-1 text-gray-700 list-disc">
              <li>Exposure principles (aperture, shutter speed, ISO)</li>
              <li>Metering techniques (incident, reflected)</li>
              <li>Exposure compensation</li>
            </ul>
          </div>
          <div className="p-8 bg-white shadow-md rounded-xl" data-aos="fade-up">
            <h3 className="uppercase tracking-wide text-xl font-bold text-[#A14D1F]">Module 8: Color Theory and Grading</h3>
            <ul className="pl-5 space-y-1 text-gray-700 list-disc">
              <li>Colour theory fundamentals</li>
              <li>Colour grading techniques</li>
              <li>Colour correction software (DaVinci Resolve, Adobe Premiere)</li>
            </ul>
          </div>
          <div className="p-8 bg-white shadow-md rounded-xl" data-aos="fade-up">
            <h3 className="uppercase tracking-wide text-xl font-bold text-[#A14D1F]">Module 9: Digital Cinematography</h3>
            <ul className="pl-5 space-y-1 text-gray-700 list-disc">
              <li>Digital camera technology</li>
              <li>Digital workflows (RAW, HDR)</li>
              <li>Digital cinematography techniques</li>
            </ul>
          </div>
          <div className="p-8 bg-white shadow-md rounded-xl" data-aos="fade-up">
            <h3 className="uppercase tracking-wide text-xl font-bold text-[#A14D1F]">Module 10: Advanced Cinematography Techniques</h3>
            <ul className="pl-5 space-y-1 text-gray-700 list-disc">
              <li>Advanced lighting techniques</li>
              <li>Advanced camera movement</li>
              <li>Advanced composition and visual storytelling</li>
            </ul>
          </div>
        </div>

        {/* Instructors & Practical Experience */}
        <div className="grid grid-cols-1 gap-6 mt-10 md:grid-cols-2">
          <div className="p-8 bg-white shadow-md rounded-xl" data-aos="fade-up">
            <h3 className="uppercase tracking-wide text-xl font-bold text-[#A14D1F]">Learn from Industry Experts</h3>
            <p><strong>Faculty:</strong></p>
            <ul className="pl-5 space-y-1 text-gray-700 list-disc">
              <li>Experienced cinematographers and industry professionals</li>
            </ul>
            <p className="mt-4"><strong>Guest Lectures:</strong></p>
            <ul className="pl-5 space-y-1 text-gray-700 list-disc">
              <li>Renowned cinematographers and directors</li>
            </ul>
          </div>
          <div className="p-8 bg-white shadow-md rounded-xl" data-aos="fade-up">
            <h3 className="uppercase tracking-wide text-xl font-bold text-[#A14D1F]">Practical Experience</h3>
            <ul className="pl-5 space-y-1 text-gray-700 list-disc">
              <li><strong>Projects and Assignments:</strong> Short film projects, visual exercises, script analysis</li>
              <li><strong>Equipment:</strong> Professional camera packages (Arri, Red, Sony), lighting kits, grip equipment</li>
              <li><strong>Software Training:</strong> DaVinci Resolve, Adobe Premiere, Avid Media Composer</li>
            </ul>
          </div>
          <div className="p-8 bg-white shadow-md rounded-xl md:col-span-2" data-aos="fade-up">
            <h3 className="uppercase tracking-wide text-xl font-bold text-[#A14D1F]">Certification & Career Opportunities</h3>
            <ul className="pl-5 space-y-1 text-gray-700 list-disc">
              <li>Certificate in Cinematography upon course completion</li>
              <li>Career paths include cinematographer, camera operator, lighting technician, and director of photography in film/TV production companies</li>
            </ul>
          </div>
        </div>

        {/* Call to Action */}
        <div className="p-8 mt-10 text-center bg-white shadow-md rounded-xl" data-aos="fade-up">
          <h3 className="uppercase tracking-wide text-lg font-bold mb-4 text-[#A14D1F]">Take the Next Step in Your Filmmaking Journey</h3>
          <p className="mb-6 text-gray-700">
            Enroll in the <strong>cinematography course</strong> at Sunrising Cinevision Academy and build a career in the world of film and media. Whether you're pursuing a <strong>diploma in cinematography</strong>, a <strong>bachelor in cinematography</strong>, or a <strong>cinematography masters degree</strong>, this course equips you with the skills to excel in the industry.
          </p>
          <a href="/admission" className="inline-block px-8 py-3 text-lg font-bold text-white bg-gradient-to-r from-[#A14D1F] via-[#A14D1F] to-[#4A2F24] rounded-2xl shadow-lg hover:scale-105 transition-transform">Apply Now</a>
        </div>
      </div>
    </section>
  );
};

export default CinemtographyMain;
